<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="full"
      :contentStyle="{'height': '100%'}"
      no-padding
      @open="modalOpen"
      :footer="false">
    <template #header>
      <span>发票信息</span><span class="info-title">订单{{orderId | defaultShow}}的发票</span>
    </template>
    <template #content>
      <app-base-main
        parentTable
        :table-shadow="false">
        <template #operate-group v-if="hasData">
          <gj-button type="primary" :disabled="loading" :loading="downloadLoading" @click="download(selectedRows)">下载发票</gj-button>
          <gj-button :disabled="loading" :loading="uploadLoading" @click="upload(selectedRows)">上传发票</gj-button>
        </template>
        <template #table>
          <gj-table
            v-show="hasData"
            ref="gjTable"
            :index="false"
            adaptParent
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :show-pagination="false"
            selection>
            <template v-slot:invoiceStatus="{ row }">
              <gj-tooltip
                v-if="row.invoiceStatus === 'fail'"
                :content="row.failMsg"
                style="display: inline-flex;">
                <span class="colorRed"><i v-if="row.invoiceStatus === 'fail'" class="el-icon-warning colorRed"></i>{{ row.invoiceStatus | optionText(invoiceUploadStatusOptions) | defaultShow}}</span>
              </gj-tooltip>
              <span :class="{ 'colorOrange' : row.invoiceStatus === 'wait' }" v-else>{{ row.invoiceStatus | optionText(invoiceUploadStatusOptions) | defaultShow}}</span>
            </template>
            <template v-slot:op="{row}">
              <gj-button v-if="row.invoiceStatus === 'wait' || row.invoiceStatus === 'fail'" :loading="row.uploadLoading" type="text" @click="upload([row], row)">上传发票</gj-button>
              <gj-button v-if="row.invoiceStatus === 'success'" :loading="row.downloadLoading" type="text" @click="download([row], row)">下载发票</gj-button>
            </template>
          </gj-table>
          <template v-if="!hasData">
            <div class="wid350 mgauto">
              <div class="gj-mb5 tip-title">当前订单无可上传的发票</div>
              <div style="line-height: 30px;">
                <div>以下原因可供参考：</div>
                <div>1. 上传发票功能仅支持欧洲站点的店铺</div>
                <div>2. 当前店铺未开通VCS Lite，无法在系统中上传发票/收据</div>
                <div>3. 该订单中包含发货国缺失增值税号的情况</div>
                <div>4. 暂未获取到发票信息</div>
                <gj-link href="http://help.gerpgo.com/web/#/26/1399" target="_blank">如何开通VCS lite？</gj-link>
              </div>
            </div>
          </template>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>
<script>
  import {modalMixIn, selectionMixin, queryMixin} from "@/minxins";
  import {isMeaningful} from "@/utils/common";
  import {mapGetters} from "vuex";
  import { invoiceTypesOptions,invoiceUploadStatusOptions } from "@/utils/options";
  import { vatInvoiceInfosList } from "@/api/sale";
  import { uploadVat } from "@/api/vat";
  import { exportFile } from "@/api/common";
  export default {
    name: "sale-order-invoice-info",
    mixins: [modalMixIn, selectionMixin, queryMixin],
    props: {
      orderId: {
        required: true,
        type: String,
      },
      marketId: {
        required: true
      },
    },
    data() {
      return {
        tableData: [],
        invoiceTypesOptions,
        invoiceUploadStatusOptions,
        hasData: true,
        columns: [
          {id: 'shippingId', header: '发货单号', field: 'shippingId', minWidth: '150px', align: 'left'},
          {id: 'shipmentDate', header: '发货时间', field: 'shipmentDate', minWidth: '140px',},
          {id: 'uploadDate', header: '上传时间', field: 'uploadDate', minWidth: '140px'},
          {id: 'invoiceType', header: '发票类型', field: 'option:invoiceType', minWidth: '100px', align: 'left', options: () => this.invoiceTypesOptions},
          {id: 'invoiceNumber', header: '发票号', field: 'invoiceNumber', minWidth: '210px', align: 'left'},
          {id: 'invoiceStatus', header: '发票状态', field: 'slot:invoiceStatus', minWidth: '120px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '140px', fixed: 'right', notCustomColumn: true, disabled: true}
        ],
        loading: false,
        uploadLoading: false,
        downloadLoading: false
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          orderId: this.orderId,
          marketId: this.marketId
        };
        this.loading = true;
        vatInvoiceInfosList(params)
          .then((data) => {
            if (isMeaningful(data)) {
              data.forEach(item => {
                item.uploadLoading = false;
                item.downloadLoading = false;
              })
              this.tableData = data || [];
              this.hasData = this.tableData.length > 0;
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      // 下载发票
      download (rows, row = null) {
        if (rows.length === 0) {
          this.$message.error('请选择需要下载的发票');
          return
        }
        let downloadArr = rows.filter(item => item.invoiceStatus === 'success')
        if (downloadArr.length == 0) {
          this.$message.error('当前选中的数据暂无可下载的发票');
        } else {
          // 下载
          if(isMeaningful(row)) {
            row.downloadLoading = true;
          }else {
            this.downloadLoading = true;
          }
          exportFile(`/file/attachment/getDownloadUserDefinedFileName`, downloadArr.map(item => item.attachmentId))
            .complete(()=>{
              if(isMeaningful(row)) {
                row.downloadLoading = false;
              } else {
                this.downloadLoading = false;
              }
            })
        }
      },
      upload (rows, row = null) {
        if (rows.length === 0) {
          this.$message.error('请选择需要上传的发票')
          return
        }
        let uploadArr = rows.filter(item => item.invoiceStatus === 'wait' || item.invoiceStatus === 'fail')
        if (uploadArr.length == 0) {
          this.$message.error('当前选中的数据暂无可上传的发票')
        } else {
          // 下载
          let list = []
          uploadArr.forEach(item => list.push({ marketId: item.marketId, orderId: item.orderId, shippingId: item.shippingId, transactionId: item.transactionId }))
          if(isMeaningful(row)) {
            row.uploadLoading = true;
          } else {
            this.uploadLoading = true;
          }
          uploadVat(list).then(res => {
            this.$gjMessage.success('上传成功');
            this.$emit('query')
          }).complete(res => {
            if(isMeaningful(row)) {
              row.uploadLoading = false;
            } else {
              this.uploadLoading = false;
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.info-title {
  margin-left: 16px;
  font-weight: 400;
  color: #666666;
}
/deep/ .el-dialog__body {
  .operate-group {
    margin: 0 0 12px 0;
  }
  .wid350 {
    width: 350px;
    color: #333333;
    .tip-title {
      font-size: 20px;
      font-weight: 500;
      color: #666666;
    }
  }
  .mgauto {
    margin: 120px auto;
  }
}
</style>